export default __webpack_public_path__ + "static/iphone-blue-2743edd80d0be17733e78b60167648cf.png";